import { useEffect, useState } from 'react';
import { winnerCards } from '../../data/winners';

const moreProjects = winnerCards
  .filter((winner) => winner.id !== 'winner-2012')
  .filter((winner) => {
    const media = winner.media.toLowerCase();
    return media.includes('installation') || media.includes('sculpture');
  })
  .slice(0, 4);

export default function JeanShin() {
  const slides = [
    { src: '/uploads/2016/11/jean_shin_intervals_1280x823.jpg', alt: 'Jean Shin work 1' },
    { src: '/uploads/2016/11/jeanshin1.jpg', alt: 'Jean Shin work 2' },
    { src: '/uploads/2016/11/jeanshin2.jpg', alt: 'Jean Shin work 3' },
    { src: '/uploads/2016/11/jeanshin3.jpg', alt: 'Jean Shin work 4' },
    { src: '/uploads/2016/11/jeanshin4.jpg', alt: 'Jean Shin work 5' },
  ];
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    if (slides.length <= 1) {
      return undefined;
    }

    const intervalId = window.setInterval(() => {
      setActiveSlide((currentSlide) => (currentSlide + 1) % slides.length);
    }, 3500);

    return () => window.clearInterval(intervalId);
  }, [slides.length]);

  return (
    <section className="portfolio-item-page">
      <div className="mx-auto max-w-7xl px-5 py-10 md:px-8">
        <h1 className="subheading uppercase">Jean Shin</h1>

        <div className="portfolio-item-intro">
          <div className="portfolio-item-gallery">
            <div className="portfolio-item-slideshow">
              <div className="portfolio-item-slideshow-frame" aria-label="Jean Shin slideshow">
                {slides.map((slide, index) => (
                  <img
                    key={slide.src}
                    className={`portfolio-item-slide ${index === activeSlide ? 'portfolio-item-slide-active' : ''}`}
                    src={slide.src}
                    alt={slide.alt}
                    aria-hidden={index !== activeSlide}
                  />
                ))}
              </div>
              <div className="portfolio-item-slideshow-dots" aria-label="Slideshow progress">
                {slides.map((slide, index) => (
                  <button
                    key={slide.src}
                    type="button"
                    className={`portfolio-item-dot ${index === activeSlide ? 'portfolio-item-dot-active' : ''}`}
                    onClick={() => setActiveSlide(index)}
                    aria-label={`Show slide ${index + 1}`}
                    aria-pressed={index === activeSlide}
                  />
                ))}
              </div>
            </div>
          </div>

          <div className="portfolio-item-description">
            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1.25rem', padding: '0 0' }}>2012</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '2rem 0 0', fontWeight: '700'}}>Juror's Statement</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '0 0' }}>Jean Shin brings extraordinary sensitivity and empathy to her materials—often unappreciated and discarded—and transforms them into impressive, even magical constructions with a meticulous hand. For Shin, the process of procuring these not-so-raw ingredients often entails a degree of community engagement and can be as important as the finished product. Her art helps viewers understand that objects are important not only for their inherent qualities but for the stories, histories, and meanings invested in them by the people who possessed and used, or forgot and abandoned them. Shin’s body of work is already impressive, and the power of her work is evidenced by her long history of projects and exhibitions at many respected institutions. We the jurors are delighted to give this year’s KAFA Award to such an accomplished artist.</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '3rem 0 0', fontWeight: '700' }}>Jurors</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '2', fontSize: '1rem', padding: '0 0' }}>Carol Eliel, Curator of Modern Art, LACMA</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '2', fontSize: '1rem', padding: '0 0' }}>Leah Ollman, Writer, Los Angeles Times and Art in America</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '2', fontSize: '1rem', padding: '0 0' }}>Doryun Chong, Associate Curator of painting and sculpture, Museum of Modern Art in New York</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '3rem 0 0', fontWeight: '700' }}>Biography</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', paddingBottom: '2rem' }}>Jean Shin is nationally recognized for her monumental installations that transform everyday objects into elegant expressions of identity and community. For each project, she amasses vast collections of a particular object-prescription pill bottles, sports trophies, sweaters- which are often sourced through donations from individuals in a participating community. These intimate objects then become the materials for her conceptually rich sculptures, videos, and site-specific installations. Distinguished by her meticulous, labor-intensive process, and her engagement of the community, Shin’s arresting installations reflect individuals’ personal lives as well as collective issues that we face as a society.</p>
            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', paddingBottom: '2rem' }}>Her work has been widely exhibited in major national and international museums, including in solo exhibitions at the Scottsdale Museum of Contemporary Art in Arizona (2010), Smithsonian American Art Museum in Washington DC (2009), the Fabric Workshop and Museum in Philadelphia (2006), and Projects at The Museum of Modern Art in New York (2004).</p>
            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', paddingBottom: '2rem' }}>Other venues have been the New Museum of Contemporary Art, the Museum of Art and Design, the Museum of Fine Arts, Houston, the Museum of Fine Arts, Boston, Asia Society and Museum, The Brooklyn Museum, Sculpture Center, Socrates Sculpture Park, and Frederieke Taylor Gallery in New York City. Site-specific permanent installations have been commissioned by the US General Services Administration Art in Architecture Award, New York City’s Percent for the Arts and MTA Art for Transit. She has received numerous awards, including the New York Foundation for the Arts Fellowship in Architecture/Environmental Structures (2008) and Sculpture (2003), Pollock-Krasner Foundation Grant, and Louis Comfort Tiffany Foundation Biennial Art Award. Her works have been featured in many publications, including Frieze Art, Flash Art, Tema Celeste, Art in America, Sculpture Magazine, Artnews, and The New York Times.</p>
            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', paddingBottom: '2rem' }}>Born in Seoul, South Korea and raised in the United States, Shin attended the Skowhegan School of Painting and Sculpture in 1999 and received a BFA and MS from Pratt Institute in Brooklyn. She lives and works in New York City.</p>

            <a href='https://www.jeanshin.com/' className='nav-link'>Artist's Website</a>
          </div>
        </div>
      </div>

      <section className="portfolio-item-more-projects w-full" aria-labelledby="more-projects-heading">
        <div className="mx-auto max-w-7xl px-5 md:px-8">
          <h2 className="subheading" id="more-projects-heading" style={{ marginBottom: '1.5rem' }}>
            More projects
          </h2>
        </div>

        <div className="winners-grid portfolio-item-more-grid">
          {moreProjects.map((winner) => (
            <a
              key={winner.id}
              href={winner.href}
              className="winner-card"
              aria-label={`${winner.year} ${winner.media} by ${winner.name}`}
            >
              <img className="winner-card-image" src={winner.image} alt="" />
              <div className="winner-card-overlay">
                <div className="winner-card-portrait-wrap">
                  <img className="winner-card-portrait" src={winner.portrait} alt="" />
                </div>
                <div className="winner-card-copy">
                  <span className="winner-card-meta">
                    {winner.year} | {winner.media}
                  </span>
                  <span className="winner-card-name">{winner.name}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </section>
    </section>
  );
}
